import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import ActionBarItemContentWrapper from '../ActionBarItemContentWrapper';
import s from './ActionBarButton.scss';
/**
 * A button for our `ActionBar`.
 */
var ActionBarButton = function (_a) {
    var className = _a.className, dataHook = _a.dataHook, children = _a.children, rest = __rest(_a, ["className", "dataHook", "children"]);
    return (React.createElement(PlainButtonOrLink, __assign({ className: c(s['root'], className), "data-hook": dataHook }, rest),
        React.createElement(ActionBarItemContentWrapper, null, children)));
};
ActionBarButton.displayName = 'ActionBarButton';
export default ActionBarButton;
//# sourceMappingURL=ActionBarButton.js.map